import React,{Components} from 'react';
import {Card, Button, CardTitle, CardDeck,CardText, CardHeader,CardBody ,Row, Col, CardSubtitle } from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export default class KrazySwap extends React.Component{
constructor(props){
    super(props)
    this.state={
        zilAmount:0,
        kkzAmount:0,
        soulzAmount:0,
        demonzAmount:0,
        angilzAmount:0

    }
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.handleSoulzSubmit=this.handleSoulzSubmit.bind(this);
    this.handleChangeSoulz=this.handleChangeSoulz.bind(this);

}

async componentDidMount(){

}

handleChangeSoulz(event){
    this.setState({soulzValue:event.target.value});
}

handleSoulzSubmit(event){
    event.preventDefault();

}

handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.value != 0) {      


    } else {

      MySwal.fire({
        title: 'Error',
        text: 'You need to enter more than 0',
        icon: 'error'
      });
    }
  }

render(){
    return(
        <div>
            <div>
            <center>
          <Card body inversse style={{maxWidth:'600px',backgroundColor:'#333',borderColor:'lime',color:'white',display:'flex'}}>
                <CardTitle>Available in Phase 3 up to the end of Phase 4</CardTitle>
                <CardText>
                    </CardText>
                    </Card>
                    </center>
            </div>
            <br/><br/>
          <div>
              <center>
          <Card body inversse style={{maxWidth:'600px',backgroundColor:'#333',borderColor:'lime',color:'white',display:'flex'}}>
                <CardTitle>KrazySwap for LPairing</CardTitle>
                <CardText>
                <form>
        <label>
          KKZ/SOLZ<br/>
          <br/>
          KKZ Amount:<br/>
          <input type="text" value={this.state.value} onChange={this.handleChange} />
        </label><br/>
      </form><br/><br/>
      <form onSubmit={this.handleSubmit}>
        <label>
          SOLZ Amount:<br/>
          <input type="text" value={this.state.soulzValue} onChange={this.handleChangeSoulz} />
        </label><br/>
        <input disabled='true' type="submit" value="Create Pair" />

      </form><br/><br/>
      You will receive:<br/>
      0
                </CardText>
                  </Card>
              </center>
          </div>
          <br/><br/>
        </div>

    );
  }

}